import React from "react";
import MessagesIcon from "assets/Icon_Header_01.png";

type LoggedInHeaderMessagesIconProps = {
  unreadMessages?: string;
};

const LoggedInHeaderMessagesIcon: React.FC<LoggedInHeaderMessagesIconProps> = ({
  unreadMessages,
}) => {
  return (
    <div className="LoggedInHeaderMessagesIcon">
      {unreadMessages && unreadMessages !== "0" ? (
        <div className="LoggedInHeaderMessagesIcon__notifications">
          {unreadMessages}
        </div>
      ) : (
        ""
      )}
      <img src={MessagesIcon} alt="icon"></img>
    </div>
  );
};

export default LoggedInHeaderMessagesIcon;
